import { render, staticRenderFns } from "./ImageThumbnail.vue?vue&type=template&id=bcf10388&scoped=true&"
import script from "./ImageThumbnail.vue?vue&type=script&lang=js&"
export * from "./ImageThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf10388",
  null
  
)

export default component.exports